import { Review } from "../types";
import apiClient from "./apiClient";

export const fetchReviewsForProduct = async (productId: number): Promise<Review[]> => {
  const response = await apiClient.get<{ reviews: Review[] }>(`/api/products/${productId}/reviews`);
  return response.data.reviews || [];
};

export const createReview = async (productId: number, reviewData: Partial<Review>) => {
  await apiClient.post(`/api/products/${productId}/reviews`, reviewData);
};
